"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOpml = void 0;
const utils_1 = require("../utils");
/**
 * Transforms parsed OPML XML data into an array of objects containing feed URLs and titles.
 *
 * @param xmlText - The OPML XML data as a string.
 * @returns An array of objects with each object containing a feed URL and an optional title.
 * @throws If the expected XML structure is not found.
 */
function transformOpml(xmlText) {
    const parsedXML = (0, utils_1.parseXml)(xmlText);
    const { opml } = parsedXML;
    if (!(opml === null || opml === void 0 ? void 0 : opml.body)) {
        throw new Error("Expected XML structure not found");
    }
    let outlines = [];
    if (opml.body.outline) {
        if (Array.isArray(opml.body.outline)) {
            outlines = opml.body.outline;
        }
        else if (typeof opml.body.outline === "object" && "outline" in opml.body.outline) {
            const container = opml.body.outline;
            if (Array.isArray(container.outline)) {
                outlines = container.outline;
            }
            else if (container.outline) {
                outlines = [container.outline];
            }
        }
        else {
            outlines = [opml.body.outline];
        }
    }
    return outlines
        .filter((outline) => outline["@_xmlUrl"] !== undefined)
        .map((outline) => ({
        title: outline["@_text"],
        url: outline["@_xmlUrl"],
    }));
}
exports.transformOpml = transformOpml;
